module.exports = __webpack_public_path__ + "static/media/08_MINS-2.3-EH-10 1.9641c75d.svg";